module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/areas/area/textures/parquet.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/areas/area/textures/parquet.jpg
// module id = 461
// module chunks = 0